import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Wallet: React.FC<IconProps> = ({
  color = '#fff',
  size = 25,
  className,
  style,
  ...rest
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={19.2} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M4.034 2c-1.435 0-2.188.876-2.188 2.188v11.624c0 1.313.753 2.188 2.188 2.188h16.932c1.435 0 2.188-.875 2.188-2.188V4.188c0-1.312-.753-2.188-2.188-2.188H4.034Z"
      />
      <path
        fill="#F16D5E"
        d="M4.207 2.897c-1.136 0-1.474.68-1.474 1.526v5.564l5.012.01c1.339.002 1.887.54 2.445 1.294.142.192.315.452.484.621a2.573 2.573 0 0 0 1.826.757c.661 0 1.322-.252 1.826-.757.169-.169.342-.429.484-.62.558-.755 1.106-1.293 2.445-1.296l5.012-.01V4.424c0-.845-.338-1.526-1.474-1.526H4.207Z"
      />
      <path
        fill="#3295C9"
        d="M4.207 2.897c-1.136 0-1.474.68-1.474 1.526v1.783c0-.846.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V4.423c0-.845-.338-1.526-1.474-1.526H4.207Z"
      />
      <mask
        id="b"
        width={21}
        height={5}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M4.207 2.897c-1.136 0-1.474.68-1.474 1.526v1.783c0-.846.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V4.423c0-.845-.338-1.526-1.474-1.526H4.207Z"
        />
      </mask>
      <g filter="url(#c)" mask="url(#b)">
        <path
          fill="#000"
          fillOpacity={0.318}
          d="M4.207 4.68c-1.136 0-1.474.68-1.474 1.526v1.782c0-.845.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V6.206c0-.846-.338-1.526-1.474-1.526H4.207Z"
        />
      </g>
      <path
        fill="#FCAD00"
        d="M4.207 4.68c-1.136 0-1.474.68-1.474 1.526v1.782c0-.845.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V6.206c0-.846-.338-1.526-1.474-1.526H4.207Z"
      />
      <mask
        id="d"
        width={21}
        height={4}
        x={2}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M4.207 4.68c-1.136 0-1.474.68-1.474 1.526v1.782c0-.845.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V6.206c0-.846-.338-1.526-1.474-1.526H4.207Z"
        />
      </mask>
      <g filter="url(#e)" mask="url(#d)">
        <path
          fill="#000"
          fillOpacity={0.314}
          d="M4.207 6.462c-1.136 0-1.474.68-1.474 1.526v1.783c0-.846.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V7.988c0-.845-.338-1.526-1.474-1.526H4.207Z"
        />
      </g>
      <path
        fill="#50BE3D"
        d="M4.207 6.462c-1.136 0-1.474.68-1.474 1.526v1.783c0-.846.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V7.988c0-.845-.338-1.526-1.474-1.526H4.207Z"
      />
      <mask
        id="f"
        width={21}
        height={4}
        x={2}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M4.207 6.462c-1.136 0-1.474.68-1.474 1.526v1.783c0-.846.338-1.526 1.474-1.526h16.586c1.136 0 1.474.68 1.474 1.526V7.988c0-.845-.338-1.526-1.474-1.526H4.207Z"
        />
      </mask>
      <g filter="url(#g)" mask="url(#f)">
        <path
          fill="#000"
          fillOpacity={0.314}
          d="M4.207 8.245c-1.136 0-1.474.68-1.474 1.526v1.782c0-.845.338-1.526 1.474-1.526h16.586c1.136 0 1.474.681 1.474 1.527V9.77c0-.846-.338-1.526-1.474-1.526H4.207Z"
        />
      </g>
      <mask
        id="h"
        width={21}
        height={5}
        x={2}
        y={8}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M4.207 8.245c-1.136 0-1.474.68-1.474 1.526v.216l5.012.01c1.339.002 1.887.54 2.445 1.294.142.192.315.452.484.621a2.572 2.572 0 0 0 1.826.757c.661 0 1.322-.252 1.826-.757.169-.169.342-.429.484-.62.558-.755 1.106-1.293 2.445-1.296l5.012-.01v-.215c0-.846-.338-1.526-1.474-1.526H4.207Z"
        />
      </mask>
      <g filter="url(#i)" mask="url(#h)">
        <path
          fill="#F26D5F"
          fillOpacity={0.298}
          d="M4.034 2c-1.435 0-2.188.876-2.188 2.188v11.624c0 1.313.753 2.188 2.188 2.188h16.932c1.435 0 2.188-.875 2.188-2.188V4.188c0-1.312-.753-2.188-2.188-2.188H4.034Zm.173.897h16.586c1.136 0 1.474.68 1.474 1.526v5.564l-5.012.01c-1.339.002-1.887.54-2.445 1.294-.142.192-.315.452-.484.621a2.573 2.573 0 0 1-1.826.757 2.573 2.573 0 0 1-1.826-.757c-.169-.169-.342-.429-.484-.62-.558-.755-1.106-1.293-2.445-1.296l-5.012-.009V4.423c0-.845.338-1.526 1.474-1.526Z"
        />
      </g>
      <path fill="url(#j)" d="M1.846 8.68h.887v1.307h-.887V8.681Z" />
      <path fill="url(#k)" d="M22.267 8.68h.887v1.307h-.887V8.681Z" />
    </g>
    <defs>
      <filter
        id="c"
        width={73.402}
        height={57.177}
        x={-24.201}
        y={-22.254}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_31609_80927"
          stdDeviation={13.467}
        />
      </filter>
      <filter
        id="e"
        width={73.402}
        height={57.177}
        x={-24.201}
        y={-20.472}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_31609_80927"
          stdDeviation={13.467}
        />
      </filter>
      <filter
        id="g"
        width={73.402}
        height={57.177}
        x={-24.201}
        y={-18.689}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_31609_80927"
          stdDeviation={13.467}
        />
      </filter>
      <filter
        id="i"
        width={88.279}
        height={82.971}
        x={-31.64}
        y={-31.485}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_31609_80927"
          stdDeviation={16.743}
        />
      </filter>
      <linearGradient
        id="j"
        x1={1.846}
        x2={1.846}
        y1={9.987}
        y2={9.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC9BE" />
        <stop offset={1} stopColor="#C8C5BB" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="k"
        x1={22.267}
        x2={22.267}
        y1={9.987}
        y2={9.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC9BE" />
        <stop offset={1} stopColor="#C8C5BB" stopOpacity={0} />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M1.846 2h21.309v16H1.845z" />
      </clipPath>
    </defs>
  </svg>
)
